import { ApiUrl } from "./common/Config";
import { post } from "./common/Helper";

// ─── İçerik Takip (Content Tracking) ────────────────────────────────────────────
// Backend filters by ClassId only (= ClassTypeId from CMS/getsegments); course
// filtering (by CourseId) and search happen on the frontend.
// Envelope: { ResponseStatus, ResponseData: [...rows], ResponseMessage }

/**
 * Soru Takip.  POST contenttracking/questiondetail   payload: { ClassId }
 * Row: { ClassName, CourseId, CourseName, SegmentTopicName, AchievementName,
 *        AchievementId, QuestionCount, QuestionStatus ("completed" | "missing"),
 *        VideoNoneCount, DownloadedCount, UploadedCount, ApprovedCount, ConvertedCount }
 * Video log status: 0 Video Yok · 1 Downloaded · 2 Uploaded · 3 Approved · 4 Converted
 */
export const getQuestionTracking = async (classId, token) => {
  const url = ApiUrl + "cms/questiondetail";
  return await post(url, { ClassId: classId }, token);
};

/**
 * Ders Videosu.  POST contenttracking/videodetail   payload: { ClassId }
 * Row: { ClassName, CourseId, CourseName, SegmentTopicName, AchievementName,
 *        AchievementId, VideoCount, ApprovedInteractionVideoCount,
 *        ReadyCount (Status 3), UploadedCount (Status 4), DoneCount (Status 5) }
 */
export const getVideoTracking = async (classId, token) => {
  const url = ApiUrl + "cms/videodetail";
  return await post(url, { ClassId: classId }, token);
};
